import styled from 'styled-components';
import { getStyles, getTypographyStyles } from '../../../utils/getStyles/getStyles';
export const StyledHelperTextWrapper = styled.div `
  ${props => getStyles(props.styles.helperTextContainer)}
`;
export const StyledLeftHelperText = styled.div `
  ${props => getStyles(props.styles.helperTextLeftContainer)}
  ${props => getTypographyStyles(props.styles.helperTextLeftContainer)}
`;
export const StyledRightHelperText = styled.div `
  ${props => getStyles(props.styles.helperTextRightContainer)}
  ${props => getTypographyStyles(props.styles.helperTextRightContainer)}
`;
//# sourceMappingURL=sliderHelperTextStandAlone.styled.js.map